export default "__VITE_ASSET__hYEScCyz__"